import React from 'react';

export function ProjectTasksOverdue() {
  const overdueTasks = [
    {
      id: '1',
      name: 'Lắp đặt hệ thống tưới tự động',
      location: 'Khu A - Hệ thống tưới',
      overdueDays: 5
    },
    {
      id: '2',
      name: 'Tiểu cảnh & hồ nước',
      location: 'Khu A - Tiểu cảnh',
      overdueDays: 3
    }
  ];

  return (
    <div className="bg-white rounded-md border border-slate-100 p-4  space-y-4">
      <div className="flex items-center justify-between border-b border-slate-50 pb-2">
        <h3 className="text-sm font-normal text-slate-900">Công việc quá hạn</h3>
        <button className="text-xs font-normal text-rose-600 hover:underline">Chi tiết</button>
      </div>

      <div className="space-y-3">
        {overdueTasks.map(task => (
          <div key={task.id} className="flex gap-3 p-2 rounded-md border border-slate-50 hover:bg-slate-50 transition-colors cursor-pointer group">
            <div className="w-8 h-8 shrink-0 rounded-md bg-rose-50 flex items-center justify-center text-rose-500">
              <i className="ri-error-warning-line text-lg" />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-xs font-normal text-slate-700 truncate group-hover:text-emerald-600 transition-colors">{task.name}</h4>
              <p className="text-xs font-normal text-rose-500">{task.dueDate}</p>
            </div>
            <div className="text-right">
              <span className="text-xs font-normal text-rose-500 whitespace-nowrap">Quá hạn {task.overdueDays} ngày</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
